// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9359e179-0b39-4e87-9693-5e434aa54b2e',
      type: 'Sprite',
      name: 'darkTile',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_dark',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '22eaa2cf-b436-499d-8ff0-a883cd717a4a',
      type: 'Sprite',
      name: 'highlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_hover',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd15a726c-549d-4952-91cc-39e9b4726240',
      type: 'Container',
      name: 'particles',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'e133f1c8-03ad-430a-bf15-1f1711f251c9',
      type: 'Container',
      name: 'coin',
      className: '',
      x: 0,
      y: 7,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '3c35fece-7818-4eee-8271-1aa5862b5aaf',
      type: 'Text',
      name: 'coinAmount',
      className: '',
      x: 0,
      y: -42,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '300',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ccfa9cf5-2e55-407c-a58f-8372efff5764',
      type: 'Container',
      name: 'coinBottom',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e133f1c8-03ad-430a-bf15-1f1711f251c9'
    },
    {
      id: '777ea821-f50e-4402-ab75-d1029824046b',
      type: 'Container',
      name: 'coinTop',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e133f1c8-03ad-430a-bf15-1f1711f251c9'
    },
    {
      id: 'f72bb6c9-bff9-4deb-9d87-b531b26c7564',
      type: 'Sprite',
      name: 'coinFull',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Locked_Tiles_Icon',
      parent: 'e133f1c8-03ad-430a-bf15-1f1711f251c9'
    },
    {
      id: 'b902e239-92cc-4107-b9f5-efd09ca5cf5d',
      type: 'Sprite',
      name: 'coinWhite',
      className: '',
      x: 0,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Locked_Tiles_Icon_White',
      parent: 'e133f1c8-03ad-430a-bf15-1f1711f251c9'
    },
    {
      id: '77313f9e-9abd-486d-9f88-2685fd5c784c',
      type: 'Sprite',
      name: 'coinBottomNormal',
      className: '',
      x: 0,
      y: 10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Locked_Tiles_Icon_Bottom',
      parent: 'ccfa9cf5-2e55-407c-a58f-8372efff5764'
    },
    {
      id: '366e4719-336a-4d7b-b4c5-4b779aee5e47',
      type: 'Sprite',
      name: 'coinBottomWhite',
      className: '',
      x: 0,
      y: 10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Locked_Tiles_Icon_Bottom_White',
      parent: 'ccfa9cf5-2e55-407c-a58f-8372efff5764'
    },
    {
      id: '08cbe7a9-8552-45cf-af7d-acdf68d3e819',
      type: 'Sprite',
      name: 'coinTopNormal',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Locked_Tiles_Icon_Top',
      parent: '777ea821-f50e-4402-ab75-d1029824046b'
    },
    {
      id: '65dbd5b1-4e65-4529-b447-58efec42287d',
      type: 'Sprite',
      name: 'coinTopWhite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Locked_Tiles_Icon_Top_White',
      parent: '777ea821-f50e-4402-ab75-d1029824046b'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: '5e2cec58-ec83-4be0-a8b2-7073a12e4cf1',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 5000,
      blocks: [
        {
          id: '36059b6e-08f6-43e6-8796-f4ceaaf3bded',
          type: 'Tween',
          name: 'coinPosition',
          duration: 700,
          track: 2,
          target: {
            scale: {},
            y: 5
          },
          startAt: 1000,
          sourceName: 'coin',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'eb51af1a-84d6-4a91-849e-501abb556af1',
          type: 'Tween',
          name: 'coinRotation_2',
          duration: 500,
          track: 3,
          target: {
            angle: -30
          },
          startAt: 1000,
          sourceName: 'coin',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ac36ba6c-bf24-4272-9d5c-9570f63b4cdd',
          type: 'Tween',
          name: 'coinBottomPosition',
          duration: 700,
          track: 7,
          target: {
            scale: {
              y: 1.2
            },
            y: -6
          },
          startAt: 1000,
          sourceName: 'coinBottom',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3b438b4d-b0d3-4370-bdc5-e02c39b24ffa',
          type: 'Tween',
          name: 'coinTopScale',
          duration: 700,
          track: 5,
          target: {
            scale: {
              y: 1.2
            }
          },
          startAt: 1000,
          sourceName: 'coinTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '93ba2970-bdd9-4567-abcd-333453319c49',
          type: 'Tween',
          name: 'coinTopWhiteAlpha',
          duration: 350,
          track: 4,
          target: {
            alpha: 0.3
          },
          startAt: 1250,
          sourceName: 'coinTopWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f2c8c5ad-942b-416e-a216-070d425fe043',
          type: 'Tween',
          name: 'coinRotation_1',
          duration: 450,
          track: 3,
          target: {
            angle: 30
          },
          startAt: 1500,
          sourceName: 'coin',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '3c1d2b18-3404-411b-847f-cfe58b537bf0',
          type: 'Tween',
          name: 'coinTopWhiteAlpha_1',
          duration: 350,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 1600,
          sourceName: 'coinTopWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd259122f-c831-4723-b970-139938f417c7',
          type: 'Tween',
          name: 'coinPosition_copy',
          duration: 700,
          track: 2,
          target: {
            scale: {},
            y: 7
          },
          startAt: 1700,
          sourceName: 'coin',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9c7bc04e-f3fa-4a40-b5ce-f19a5c7fdac2',
          type: 'Tween',
          name: 'coinTopScale_1',
          duration: 700,
          track: 5,
          target: {
            scale: {
              y: 1
            }
          },
          startAt: 1700,
          sourceName: 'coinTop',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ca43ad9f-37fe-4d6a-b1ff-16054b13870c',
          type: 'Tween',
          name: 'coinBottomPosition_1',
          duration: 700,
          track: 7,
          target: {
            scale: {
              y: 1
            },
            y: 0
          },
          startAt: 1700,
          sourceName: 'coinBottom',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8c8b9618-3e2f-4cfb-9887-73fed4a6a4bf',
          type: 'Tween',
          name: 'coinRotation_copy',
          duration: 450,
          track: 3,
          target: {
            angle: 0
          },
          startAt: 1950,
          sourceName: 'coin',
          easing: 'QuadraticOut',
          disabled: false
        }
      ]
    },
    {
      id: 'eb47babd-a517-4304-9d90-0ccedd9c650a',
      name: 'Unlock',
      playingSpeed: 1,
      totalDuration: 1200,
      blocks: [
        {
          id: 'a7b504da-1d1f-4308-90b2-2571f110f750',
          type: 'Tween',
          name: 'coinAmountScale',
          duration: 100,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'coinAmount',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e246daee-eac8-49c7-9693-ee59dbd714e8',
          type: 'Setter',
          name: 'coinFullAlpha',
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 40,
          sourceName: 'coinFull',
          disabled: false
        },
        {
          id: '5e3b6d3e-d87e-4c9f-9e1b-379c2d8704dc',
          type: 'Setter',
          name: 'coinTopAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 40,
          sourceName: 'coinTop',
          disabled: false
        },
        {
          id: '65878fb6-04da-4587-a7d5-28e1afdb6b77',
          type: 'Setter',
          name: 'coinBottomAlpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 40,
          sourceName: 'coinBottom',
          disabled: false
        },
        {
          id: '1e4a7cbc-a081-4570-8d4e-9a3b69703407',
          type: 'Setter',
          name: 'FXPART_Unlock_Tile_Particles',
          track: 9,
          target: {},
          startAt: 50,
          sourceName: 'particles',
          disabled: false
        },
        {
          id: '1406b3bf-a98b-4985-b31a-87c4ede96296',
          type: 'Tween',
          name: 'coinScale',
          duration: 100,
          track: 4,
          target: {
            scale: {
              x: 0.9,
              y: 0.9
            }
          },
          startAt: 50,
          sourceName: 'coin',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0428622b-d3d9-4513-8ab1-fb300ed73a46',
          type: 'Tween',
          name: 'highlightAlpha',
          duration: 200,
          track: 8,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'highlight',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b7883ec2-10c2-4c74-9516-dd6f854f3534',
          type: 'Tween',
          name: 'coinAmountScale_1',
          duration: 250,
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 100,
          sourceName: 'coinAmount',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f47d6ae7-7ecd-4db7-bf87-bbaa6610a443',
          type: 'Setter',
          name: 'SFX_Gameplay_Unlock_Tile',
          track: 10,
          target: {},
          startAt: 150,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '04a0744d-9a8c-4ecf-be6f-400d1ad45671',
          type: 'Tween',
          name: 'New_tween',
          duration: 200,
          track: 6,
          target: {
            alpha: 1,
            scale: {
              x: 0.95,
              y: 0.95
            }
          },
          startAt: 150,
          sourceName: 'coinWhite',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f33c4363-87f0-4c20-8f92-ac85740842db',
          type: 'Tween',
          name: 'coinScale_1',
          duration: 300,
          track: 4,
          target: {
            scale: {
              x: 1.3,
              y: 1.3
            },
            y: -5
          },
          startAt: 150,
          sourceName: 'coin',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd29be92f-f1d6-47df-982e-4ee5bbadd9e8',
          type: 'Tween',
          name: 'highlightAlpha_1_1',
          duration: 250,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 300,
          sourceName: 'highlight',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '94fc2b97-033b-43f2-a792-f88d29dd260e',
          type: 'Tween',
          name: 'coinAlpha',
          duration: 150,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 300,
          sourceName: 'coin',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'f0541525-2e2d-4abf-b4dd-071a4d983add',
          type: 'Tween',
          name: 'darkTileAlpha',
          duration: 300,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 450,
          sourceName: 'darkTile',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CoinBlockerLayout {
  static raw = raw;
  root!: Container;
  darkTile!: Sprite;
  highlight!: Sprite;
  particles!: Container;
  coin!: Container;
  coinAmount!: Text;
  coinBottom!: Container;
  coinTop!: Container;
  coinFull!: Sprite;
  coinWhite!: Sprite;
  coinBottomNormal!: Sprite;
  coinBottomWhite!: Sprite;
  coinTopNormal!: Sprite;
  coinTopWhite!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle {
  Layout: {
    coin: object;
    coinBottom: object;
    coinTop: object;
    coinTopWhite: object;
  };

  BlockTypeByName: {
    coinPosition: object;
    coinRotation_2: object;
    coinBottomPosition: object;
    coinTopScale: object;
    coinTopWhiteAlpha: object;
    coinRotation_1: object;
    coinTopWhiteAlpha_1: object;
    coinPosition_copy: object;
    coinTopScale_1: object;
    coinBottomPosition_1: object;
    coinRotation_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Unlock {
  Layout: {
    coinAmount: object;
    coinFull: object;
    coinTop: object;
    coinBottom: object;
    particles: object;
    coin: object;
    highlight: object;
    root: object;
    coinWhite: object;
    darkTile: object;
  };

  BlockTypeByName: {
    coinAmountScale: object;
    coinFullAlpha: object;
    coinTopAlpha: object;
    coinBottomAlpha: object;
    FXPART_Unlock_Tile_Particles: object;
    coinScale: object;
    highlightAlpha: object;
    coinAmountScale_1: object;
    SFX_Gameplay_Unlock_Tile: object;
    New_tween: object;
    coinScale_1: object;
    highlightAlpha_1_1: object;
    coinAlpha: object;
    darkTileAlpha: object;
  };

  flowData = raw.animations[1];
}
